<template>
    <v-container class="pa-2" fluid>
        <v-alert :value="error != null" type="error">
            <span>{{ error }}</span>
        </v-alert>
        <v-card v-if="error == null">
            <v-toolbar card color="primary subheading" dark>
                <span class="title">NuPoint Spray Management</span>
                <v-spacer></v-spacer>
                <v-icon dark large>insert_invitation</v-icon>
            </v-toolbar>
            <v-container class="pa-0" fluid>
                <NuPointSprayJobFilters></NuPointSprayJobFilters>
                <v-layout pl-4 pr-4>
                    <v-flex xs12>
                        <hr />
                    </v-flex>
                </v-layout>
                <v-layout column>                   
                        <!-- Main Content -->
                        <v-flex shrink>
                            <NuPointSprayJobTable></NuPointSprayJobTable>
                        </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import NuPointSprayJobFilters from '@/components/nuPointSpray/NuPointSprayJobFilters.vue'
import NuPointSprayJobTable from '@/components/nuPointSpray/NuPointSprayJobTable.vue'

export default {
    components: {
        NuPointSprayJobFilters,
        NuPointSprayJobTable
    },
    data(){
        return {
        }
    },
    computed: {
        ...mapState("NuPointSprayStore", [
            "loadingJobs",            
            "error",
            "nuPointSprayJobs"
        ])
    },
    methods: {
        ...mapActions("NuPointSprayStore", [
            "loadPlants"
        ])
    }
}
</script>

